import { TEMP_SECRET_KEY } from "../config";

const encoder = new TextEncoder();
const decoder = new TextDecoder();

const IV_LENGTH = 12;
const AUTH_TAG_LENGTH = 16;

async function getKey() {
  const keyMaterial = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(TEMP_SECRET_KEY)
  );

  return crypto.subtle.importKey(
    "raw",
    keyMaterial,
    { name: "AES-GCM" },
    false,
    ["encrypt", "decrypt"]
  );
}

function toBase64(bytes) {
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary);
}

function fromBase64(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
}

export async function encryptPassword(password) {
  const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
  const key = await getKey();

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(password)
  );

  const encryptedBytes = new Uint8Array(encryptedBuffer);

  const authTag = encryptedBytes.slice(
    encryptedBytes.length - AUTH_TAG_LENGTH
  );

  const ciphertext = encryptedBytes.slice(
    0,
    encryptedBytes.length - AUTH_TAG_LENGTH
  );

  const combined = new Uint8Array(
    IV_LENGTH + AUTH_TAG_LENGTH + ciphertext.length
  );

  combined.set(iv, 0);
  combined.set(authTag, IV_LENGTH);
  combined.set(ciphertext, IV_LENGTH + AUTH_TAG_LENGTH);

  return toBase64(combined);
}

export async function decryptPassword(secret) {
  const data = fromBase64(secret);

  const iv = data.slice(0, IV_LENGTH);
  const authTag = data.slice(IV_LENGTH, IV_LENGTH + AUTH_TAG_LENGTH);
  const ciphertext = data.slice(IV_LENGTH + AUTH_TAG_LENGTH);

  const encrypted = new Uint8Array(ciphertext.length + AUTH_TAG_LENGTH);
  encrypted.set(ciphertext);
  encrypted.set(authTag, ciphertext.length);

  const key = await getKey();

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    encrypted
  );

  return decoder.decode(decrypted);
}




export const formatChatTime = (date = new Date()) => {
  return new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};



export function getStoredLocation() {
  if (typeof window === "undefined") return null;

  try {
    const data = localStorage.getItem("userLocation");
    console.log("getStoredLocation data ", data);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}


export function Notification({ type, message, onClose }) {
  return (
    <div
      className={`notif ${type === "success" ? "notifSuccess" : "notifError"}`}
    >
      {message}
      <button className="notifClose" onClick={onClose}>×</button>
    </div>
  );
}

export const validateUserName = (name) => {
  // Remove extra spaces
  const value = name.trim();

  // Empty check
  if (!value) {
    return "Name is required";
  }

  // Minimum length
  if (value.length < 3) {
    return "Name must be at least 3 characters";
  }

  // Maximum length
  if (value.length > 200) {
    return "Name cannot exceed 40 characters";
  }

  // Only alphabets + spaces
  if (!/^[A-Za-z\s]+$/.test(value)) {
    return "Only alphabets are allowed";
  }

  // Prevent multiple spaces
  if (/\s{2,}/.test(value)) {
    return "Multiple spaces are not allowed";
  }

  return "";
};




// const encoder = new TextEncoder();
// const decoder = new TextDecoder();

// const SECRET = "TEMP_SECRET_KEY";

// async function getKey() {
//   const keyMaterial = await crypto.subtle.digest(
//     "SHA-256",
//     encoder.encode(SECRET)
//   );

//   return crypto.subtle.importKey(
//     "raw",
//     keyMaterial,
//     { name: "AES-GCM" },
//     false,
//     ["encrypt", "decrypt"]
//   );
// }

// export async function encryptPassword(password) {
//   const iv = crypto.getRandomValues(new Uint8Array(12));
//   const key = await getKey();

//   const encrypted = await crypto.subtle.encrypt(
//     { name: "AES-GCM", iv },
//     key,
//     encoder.encode(password)
//   );

//   const combined = new Uint8Array(iv.length + encrypted.byteLength);
//   combined.set(iv);
//   combined.set(new Uint8Array(encrypted), iv.length);

//   return btoa(String.fromCharCode(...combined));
// }

// export async function decryptPassword(secret) {
//   const data = Uint8Array.from(atob(secret), c => c.charCodeAt(0));

//   const iv = data.slice(0, 12);
//   const encrypted = data.slice(12);

//   const key = await getKey();

//   const decrypted = await crypto.subtle.decrypt(
//     { name: "AES-GCM", iv },
//     key,
//     encrypted
//   );

//   return decoder.decode(decrypted);
// }
